import { ChatResponseType, ChatDataType } from "@/types/ChatTypes";
import { apiChat } from "./api";

export const getTokenChat = async (): Promise<ChatDataType> => {
  const payload = {
    keyId: process.env.VUE_APP_API_CHAT_TOKEN_KEY,
    keySecret: process.env.VUE_APP_API_CHAT_TOKEN_SECRET,
  };

  const url = "/cad-api/rest/user/authentication";

  const headers = {
    "Content-Type": "application/json",
  };

  const {
    data: { token, dataExpiracao: expirationDate },
  } = await apiChat.post<ChatResponseType>(url, { ...payload }, { headers });

  return { token, expirationDate };
};
